export default __webpack_public_path__ + "static/media/authIcon.d7690dd5.svg";